function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-text-regular");

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.19,19.772 L9.17,16.888 L13.118,16.888 L14.098,19.772 L15.33,19.772 L11.914,10 L10.416,10 L7,19.772 L8.19,19.772 Z M12.824,15.852 L9.45,15.852 L11.102,11.092 L11.172,11.092 L12.824,15.852 Z M18.732,19.94 C19.236,19.94 19.67,19.828 20.034,19.604 C20.398,19.38 20.6593333,19.044 20.818,18.596 L20.818,18.596 L20.888,18.596 C20.9346667,18.932 21.049,19.212 21.231,19.436 C21.413,19.66 21.714,19.772 22.134,19.772 L22.134,19.772 L22.764,19.772 L22.764,18.792 L21.938,18.792 L21.938,14.816 C21.938,14.0506667 21.6953333,13.4533333 21.21,13.024 C20.7246667,12.5946667 20.0433333,12.38 19.166,12.38 C18.5126667,12.38 17.9713333,12.5176667 17.542,12.793 C17.1126667,13.0683333 16.8,13.402 16.604,13.794 L16.604,13.794 L17.276,14.424 C17.472,14.0973333 17.717,13.836 18.011,13.64 C18.305,13.444 18.6713333,13.346 19.11,13.346 C19.6886667,13.346 20.118,13.4813333 20.398,13.752 C20.678,14.0226667 20.818,14.4146667 20.818,14.928 L20.818,14.928 L20.818,15.642 L19.39,15.642 C18.3353333,15.642 17.5583333,15.824 17.059,16.188 C16.5596667,16.552 16.31,17.0746667 16.31,17.756 C16.31,18.428 16.5223333,18.96 16.947,19.352 C17.3716667,19.744 17.9666667,19.94 18.732,19.94 Z M18.914,18.988 C18.4753333,18.988 18.1276667,18.89 17.871,18.694 C17.6143333,18.498 17.486,18.2226667 17.486,17.868 L17.486,17.868 L17.486,17.574 C17.486,17.2193333 17.633,16.9486667 17.927,16.762 C18.221,16.5753333 18.69,16.482 19.334,16.482 L19.334,16.482 L20.818,16.482 L20.818,17.672 C20.818,17.8586667 20.7713333,18.0313333 20.678,18.19 C20.5846667,18.3486667 20.454,18.4886667 20.286,18.61 C20.118,18.7313333 19.9173333,18.8246667 19.684,18.89 C19.4506667,18.9553333 19.194,18.988 18.914,18.988 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-5.6%",
  y: "-8.0%",
  width: "117.0%",
  height: "126.2%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0.5,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-text-regular",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Aa"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000000",
  xlinkHref: "#path-1"
}))));

const SvgIco30TextRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30TextRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-text-regular.c8e81f68.svg";
export { ForwardRef as ReactComponent };